import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { removeUnmanagedMetaTags } from '../utils/metaTagCleanup';

const PRIVATE_PREFIXES = [
    '/login',
    '/email-login',
    '/sign-up',
    '/otp',
    '/logout',
    '/subscription',
    '/addons',
    '/business-plan',
    '/thank-you',
    '/ai-assistance-ans',
    '/payment-method',
    '/pay',
    '/info',
    '/account',
    '/admin',
    '/dashboard',
    '/questionnaire',
];

const RouteMeta: React.FC = () => {
    const { pathname } = useLocation();
    const isPrivate = PRIVATE_PREFIXES.some(
        pre => pathname === pre || pathname.startsWith(pre + '/')
    );

    useEffect(() => {
        removeUnmanagedMetaTags(['meta[name="robots"]']);
    }, []);

    return (
        <Helmet>
            <meta name="robots" content={isPrivate ? 'noindex, follow' : 'index, follow'} />
        </Helmet>
    );
};

export default RouteMeta;
